import store from "../store";
import iziToast from "izitoast";

export default function auth({ next, router  }) {
    if (!store.getters.getUsuario.bdt) {
        iziToast.show({theme: 'light',position: "bottomRight", message:"Debes Iniciar Sesión primero"});
        return router.push({ name: 'p1' });
    }
    return next;
}
